import React, { useState } from 'react';
import QrDniReader from './QrDniReader';
import axios from 'axios';
import { Container, Modal, FormGroup } from 'react-bootstrap';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import AutoexcluidosDetalle from './AutoexcluidosDetalle';
import { DataGrid } from '@mui/x-data-grid';

function AutoexcluidosLookup() {
  const [showQr, setShowQr] = useState(false);
  const [searchType, setSearchType] = useState('dni');
  const [searchValue, setSearchValue] = useState('');
  const [autoexcluidos, setAutoexcluidos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedAutoexcluido, setSelectedAutoexcluido] = useState(null);
  const [selectedEmpleado, setSelectedEmpleado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [buscarActivos, setBuscarActivos] = useState(true); // true para activos, false para inactivos

  const columns = [
    { field: 'nombre', headerName: 'Nombre', width: 130 },
    { field: 'fechaNacimiento', headerName: 'Fecha de Nacimiento', width: 180 },
    { field: 'vencimiento', headerName: 'Vencimiento', width: 180 },
    { field: 'dni', headerName: 'DNI', width: 130 },
    { field: 'telefono', headerName: 'Teléfono', width: 130 },
    {
      field: 'action',
      headerName: 'Detalle',
      width: 170,
      renderCell: (params) => (
        <button
          style={{
            background: params.row.empleado ? '#43a047' : '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            padding: '4px 12px',
            fontWeight: 600,
            cursor: 'pointer',
            fontSize: 15
          }}
          onClick={() => {
            if (params.row.empleado) {
              setSelectedEmpleado(params.row);
              setSelectedAutoexcluido(null);
            } else {
              setSelectedAutoexcluido(params.row);
              setSelectedEmpleado(null);
            }
            setShowModal(true);
          }}
        >
          Ver Detalle
        </button>
      ),
    },
  ];

  // Ya no se usa handleRowClick, la lógica está en el botón de la columna

  const handleSearchTypeChange = (event) => {
    setSearchType(event.target.value);
    setSearchValue('');
  };

  const handleSearchInputChange = (event) => {
    const inputValue = event.target.value;
    if ((searchType === 'dni' && /^\d*$/.test(inputValue)) || (searchType === 'nombre' && /^[a-zA-Z\s]*$/.test(inputValue))) {
      setSearchValue(inputValue);
    }
  };

  const handleSearch = async (event) => {
    event.preventDefault();
    if (searchType === 'dni' && !/^\d{7,8}$/.test(searchValue)) {
      alert('El DNI debe tener 7 u 8 dígitos numéricos.');
      return;
    }
    try {
      setLoading(true);
      let url;
      if (searchType === 'dni') {
        url = `https://us-central1-inprojuy-f1173.cloudfunctions.net/app/autoexcluidos/${searchValue}`;
      } else {
        url = `https://us-central1-inprojuy-f1173.cloudfunctions.net/app/autoexcluidos/buscar/${searchValue}`;
      }

      const params = new URLSearchParams();
      params.append('activo', buscarActivos);

      const queryString = params.toString();
      if (queryString) {
        url += `?${queryString}`;
      }

      const response = await axios.get(url);

      if (searchType === 'dni') {
        if (response.data.empleado) {
          setShowModal(true);
          setSelectedEmpleado({
            nombre: response.data.nombre,
            dni: response.data.dni,
            cargo: response.data.cargo,
            foto: response.data.foto,
          });
          setSelectedAutoexcluido(null);
        } else {
          setShowModal(true);
          setSelectedAutoexcluido(response.data);
          setSelectedEmpleado(null);
        }
      } else {
        setAutoexcluidos(response.data);
      }
    } catch (error) {
      console.error('Error fetching autoexcluidos', error);
      setAutoexcluidos([]); // Limpiar resultados en caso de error
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-5 ">
      <Container style={{ height: '100%', width: '100%' }}>
        <div style={{ height: '100%', width: '100%' }}>
          <form onSubmit={handleSearch}>
            <div
              className="radio-buttons-container"
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 8,
                alignItems: 'center',
                justifyContent: 'flex-start',
                marginBottom: 12,
                maxWidth: 600,
              }}
            >
              <div className="radio-button" style={{ minWidth: 120 }}>
                <input name="radio-group" id="radio2" className="radio-button__input" type="radio" value="dni" checked={searchType === 'dni'} onChange={handleSearchTypeChange} />
                <label htmlFor="radio2" className="radio-button__label">
                  <span className="radio-button__custom"></span>
                  Buscar por DNI
                </label>
              </div>
              <div className="radio-button" style={{ minWidth: 140 }}>
                <input name="radio-group" id="radio1" className="radio-button__input" type="radio" value="nombre" checked={searchType === 'nombre'} onChange={handleSearchTypeChange} />
                <label htmlFor="radio1" className="radio-button__label">
                  <span className="radio-button__custom"></span>
                  Buscar por nombre
                </label>
              </div>
              <input
                type={searchType === 'dni' ? 'number' : 'text'}
                value={searchValue}
                onChange={handleSearchInputChange}
                disabled={loading}
                style={{
                  flex: 1,
                  minWidth: 120,
                  maxWidth: 180,
                  marginRight: 4,
                  padding: 6,
                  borderRadius: 6,
                  border: '1px solid #ccc',
                  fontSize: 16,
                }}
                placeholder={searchType === 'dni' ? 'DNI' : 'Nombre'}
              />
            </div>
            <div
              className="d-flex align-items-center"
              style={{
                gap: 8,
                marginBottom: 12,
              }}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      checked={buscarActivos}
                      onChange={(e) => setBuscarActivos(e.target.checked)}
                      color="primary"
                    />
                  }
                  label={buscarActivos ? "Buscando: Solo Activos" : "Buscando: Solo Inactivos"}
                />
              </FormGroup>
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: '6px 16px',
                  fontSize: 15,
                  borderRadius: 6,
                  background: '#1976d2',
                  color: '#fff',
                  border: 'none',
                  minWidth: 100,
                  marginBottom: 2,
                }}
              >
                {loading ? 'Buscando...' : 'Buscar'}
              </button>
              <button
                type="button"
                onClick={() => setShowQr(true)}
                title="Escanear QR del DNI"
                style={{
                  padding: '6px 14px',
                  fontSize: 15,
                  borderRadius: 6,
                  background: 'rgb(59,160,168)',
                  color: '#fff',
                  border: 'none',
                  marginBottom: 2,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  cursor: 'pointer',
                }}
              >
                <i className="pi pi-camera" /> Escanear DNI
              </button>
            </div>
          </form>
          {showQr && (
            <Modal show={showQr} onHide={() => setShowQr(false)} size="md" centered>
              <Modal.Header closeButton>
                <Modal.Title>Escanear QR del DNI</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <QrDniReader
                  onResult={data => {
                    setShowQr(false);
                    if (data.dni) {
                      setSearchType('dni');
                      setSearchValue(data.dni);
                    }
                  }}
                  onClose={() => setShowQr(false)}
                />
              </Modal.Body>
            </Modal>
          )}
          <br />
          {selectedEmpleado && (
            <Modal show={showModal} onHide={() => setShowModal(false)} size="md" centered>
              <Modal.Header closeButton style={{ borderBottom: 'none' }}>
                <Modal.Title style={{ fontWeight: 700, fontSize: 22, color: '#1976d2', letterSpacing: 1 }}>Empleado INPROJUY</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ padding: 28, paddingTop: 10 }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
                  <div style={{ fontSize: 38, color: '#1976d2', marginBottom: 8, width: '100%', display: 'flex', justifyContent: 'center' }}>
                    {selectedEmpleado.foto ? (
                      <img
                        src={selectedEmpleado.foto}
                        alt="Foto del empleado"
                        style={{
                          width: 'min(38vw, 160px)',
                          height: 'min(38vw, 160px)',
                          maxWidth: 180,
                          maxHeight: 180,
                          minWidth: 90,
                          minHeight: 90,
                          objectFit: 'cover',
                          borderRadius: '50%',
                          border: '2.5px solid #1976d2',
                          background: '#fff',
                          marginBottom: 4,
                          boxShadow: '0 2px 12px rgba(25,118,210,0.10)'
                        }}
                      />
                    ) : (
                      <span role="img" aria-label="Empleado">👤</span>
                    )}
                  </div>
                  <div style={{ fontWeight: 600, fontSize: 20, color: '#222', textAlign: 'center', marginBottom: 2 }}>
                    {selectedEmpleado.nombre}
                  </div>
                  <div style={{ fontSize: 16, color: '#444', marginBottom: 2 }}>
                    <span style={{ fontWeight: 500, color: '#888' }}>DNI:</span> {selectedEmpleado.dni}
                  </div>
                  <div style={{ fontSize: 16, color: '#444', marginBottom: 10 }}>
                    <span style={{ fontWeight: 500, color: '#888' }}>Cargo:</span> <span style={{ color: '#1976d2', fontWeight: 600 }}>{selectedEmpleado.cargo}</span>
                  </div>
                  <button
                    onClick={() => setShowModal(false)}
                    style={{
                      background: '#1976d2',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 8,
                      fontSize: 17,
                      padding: '10px 32px',
                      marginTop: 10,
                      boxShadow: '0 2px 8px rgba(25,118,210,0.08)',
                      fontWeight: 600,
                      letterSpacing: 0.5
                    }}
                  >
                    Cerrar
                  </button>
                </div>
              </Modal.Body>
            </Modal>
          )}
          {selectedAutoexcluido && (
            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Detalle del Autoexcluido</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <AutoexcluidosDetalle
                  autoexcluidoData={selectedAutoexcluido}
                  handleModalClose={() => setShowModal(false)}
                />
              </Modal.Body>
            </Modal>
          )}
          {/* Mostrar DataGrid para ambos tipos de búsqueda */}
          {(searchType === 'nombre' || searchType === 'dni') && Array.isArray(autoexcluidos) && autoexcluidos.length > 0 && (
            <div style={{ width: '100%', minHeight: 320, maxWidth: '100vw', overflowX: 'auto' }}>
              <DataGrid
                rows={autoexcluidos}
                columns={columns}
                pageSize={5}
                loading={loading}
                checkboxSelection={false}
                autoHeight
                getRowId={(row) => row.id ?? row.dni ?? Math.random().toString(36).substr(2, 9)}
                sx={{
                  '& .MuiDataGrid-root': { fontSize: { xs: 13, sm: 15 } },
                  '& .MuiDataGrid-columnHeaders': { fontSize: { xs: 13, sm: 15 } },
                  '& .MuiDataGrid-row.empleado-row': {
                    backgroundColor: '#e8f5e9 !important',
                  },
                }}
                getRowClassName={(params) => params.row.empleado ? 'empleado-row' : ''}
              />
            </div>
          )}
        </div>
      </Container>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Detalle del Autoexcluido</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedAutoexcluido && (
            <AutoexcluidosDetalle
              autoexcluidoData={selectedAutoexcluido}
              handleModalClose={() => setShowModal(false)}
            />
          )}
        </Modal.Body>
      </Modal>

    </div>
  );
}

export default AutoexcluidosLookup;
